/*=====================================
    Router 相關

    Author: Gray
    createtime: 2017 / 12 / 21
=====================================*/

/*--------------------------
    Import
--------------------------*/
import CupoyStateProvider from 'components/commons/router/CupoyStateProvider';

/*--------------------------
    Variables
--------------------------*/
const STATES = {
    HOME: 'home',
    LOGIN: 'login',
    EMPTYINVOICE_LIST: 'emptyInvoice_list',
    ADD_EMPTYINVOICE: 'add_emptyInvoice',
    DEL_EMPTYINVOICE: 'del_emptyInvoice',
    INVOICE_LIST: 'invoice_list',
    CREATE_INVOICE: 'create_invoice',
    INVOICE_INFO: 'invoice_info',
    EDIT_INVOICE: 'edit_invoice',
    ALLOWANCE_LIST: 'allowance_list',    
    ALLOWANCE_INFO: 'allowance_info',    
    CREATE_ALLOWANCE: 'create_allowance',
    CREATE_MANUAL_ALLOWANCE: 'create_manual_allowance',
    PRINT_ALLOWANCE: 'print_allowance',
    PRIZEDINVOICE_LIST: 'prizedInvoice_list',
    CHECK_PRIZE: 'check_prize',
    TURNKEYUPLOADLOG_LIST: 'turnkeyuploadlog_list',
};

var $stateProvider = new CupoyStateProvider();

$stateProvider.otherwise('/');

$stateProvider
    .state(STATES.HOME, '/')
    .state(STATES.LOGIN, '/login')
    .state(STATES.EMPTYINVOICE_LIST, '/emptyInvoice-list/:page')
    .state(STATES.ADD_EMPTYINVOICE, '/add-emptyInvoice')
    .state(STATES.DEL_EMPTYINVOICE, '/del-emptyInvoice')
    .state(STATES.INVOICE_LIST, '/invoice-list/:page')
    .state(STATES.CREATE_INVOICE, '/create-invoice')
    .state(STATES.INVOICE_INFO, '/invoice-info/:yearmonth/:istarttag/:invoicenumber')
    .state(STATES.EDIT_INVOICE, '/edit-invoice/:yearmonth/:istarttag/:invoicenumber')
    .state(STATES.ALLOWANCE_LIST, '/allowance-list/:page')
    .state(STATES.PRINT_ALLOWANCE, '/print-allowance/:allowancenumber')
    .state(STATES.ALLOWANCE_INFO, '/allowance/:allowancenumber')
    .state(STATES.CREATE_MANUAL_ALLOWANCE, '/create-allowance/manual')
    .state(STATES.CREATE_ALLOWANCE, '/create-allowance/:yearmonth/:istarttag/:invoicenumber')
    .state(STATES.PRIZEDINVOICE_LIST, '/prizedInvoice-list/:page')
    .state(STATES.CHECK_PRIZE, '/check-prize')
    .state(STATES.TURNKEYUPLOADLOG_LIST, '/turnkeyuploadlog-list/:page')
;

var PATHS = {};

for(var key in STATES) {

    var statename = STATES[key];

    PATHS[key] = $stateProvider.absolutePathMap[statename];
}

/*--------------------------
    Method
--------------------------*/

// ------------------------------
// 取得 react router 所需要的陣列
// ------------------------------
function getReactRouterList() {

    return $stateProvider.getReactRouterList();
}

// ------------------------------
// 更新目前state
// ------------------------------
function updateCurrent(location, action) {

    return $stateProvider.updateCurrent(location, action);
}

// ------------------------------
// 更新目前state
// ------------------------------
function updateCurrentByPath(path, action) {

    return $stateProvider.updateCurrentByPath(path, action);
}

// ------------------------------
// 更新目前state
// ------------------------------
function updateCurrentByState(statename, params, querys, path, action) {

    return $stateProvider.updateCurrentByState(statename, params, querys, path, action);
}

// ------------------------------
// 取得目前state
// ------------------------------
function getCurrent() {

    return $stateProvider.current;
}

// ------------------------------
// 取得state實際網址（含querys）
// ------------------------------
function getUrl(statename, params, querys) {

    return $stateProvider.getUrl(statename, params, querys);
}

// ------------------------------
// 取得state實際網址（無querys）
// ------------------------------
function getPathname(statename, params) {

    return $stateProvider.getPathname(statename, params);
}

// ------------------------------
// 取得query網址
// ------------------------------
function getQueryUrl(querys) {

    return $stateProvider.getQueryUrl(querys);
}

// ------------------------------
// 傳入的statename是否為目前state的state或是子state
// ------------------------------
function includes(statename) {

    return $stateProvider.includes(statename);
}

// ------------------------------
// 是否有該state
// ------------------------------
function hasState(statename) {

    return $stateProvider.hasState(statename);
}

// ------------------------------
// 判斷是否在此頁
// ------------------------------
function isActive(statename, params, querys) {

    return $stateProvider.isActive(statename, params, querys);
}

// ------------------------------
// 判斷目前是否為未定義的頁面
// ------------------------------
function isUnknowState() {

    return $stateProvider.isUnknowState();
}

// ------------------------------
// 取得otherwise
// ------------------------------
function getOtherwise() {

    return $stateProvider.otherwisePath;
}

// ------------------------------
// 取得歷史記錄
// ------------------------------
function getHistory() {

    return $stateProvider.getHistory();
}

const CupoyRouter = {
    /*--------------------------
        Variables
    --------------------------*/
    STATES, // Cupoy 所有state
    PATHS, // State 對應到的 path

    /*--------------------------
        Method
    --------------------------*/
    getReactRouterList, // 取得 react router 所需要的陣列
    updateCurrent, // 更新目前state
    updateCurrentByPath, // 更新目前state
    updateCurrentByState, // 更新目前state
    getCurrent, // 取得目前state
    getUrl, // 取得state實際網址（含querys）
    getPathname, // 取得state實際網址（無querys）
    getQueryUrl, // 取得query網址
    includes, // 傳入的statename是否為目前state的state或是子state
    hasState, // 是否有該state
    isActive, // 判斷是否在此頁
    isUnknowState, // 判斷目前是否為未定義的頁面
    getOtherwise, // 取得otherwise
    getHistory, // 取得歷史記錄
};

export default CupoyRouter;



// WEBPACK FOOTER //
// ./src/components/commons/router/CupoyRouter.jsx